export class  Header {
    _id: string;
    logoImageName: string;
}
